import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CylinderSection.css";

/* ══════════════════════════════════════════
   Helpers
══════════════════════════════════════════ */

const devColor = (val) => {
  const n = Math.abs(val);

  if (n <= 5) return "#4ade80";
  if (n <= 15) return "#facc15";

  return "#f87171";
};

const fmtDev = (val) => {
  const num = Number(val || 0);
  return num >= 0 ? `+${num}` : `${num}`;
};

/* ══════════════════════════════════════════
   Component
══════════════════════════════════════════ */

const CylinderSection = ({ date }) => {
  const [cylinders, setCylinders] = useState([]);
  const [loading, setLoading] = useState(false);

  // current date
  const selectedDate = date || new Date().toISOString().split("T")[0];

  useEffect(() => {
    fetchCylinderTelemetry(selectedDate);
  }, [selectedDate]);

  const fetchCylinderTelemetry = async (date) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `https://api.hanoch.in/api/cylinder-telemetry/?date=${date}`
      );

      const apiData = response;

      // Convert API response
      const formatted = Object.keys(apiData).map((key, index) => {
        const cylinderData = apiData[key];

        const getValue = (label) => {
          return (
            cylinderData.find((item) => item.label === label)?.value ?? 0
          );
        };

        return {
          no: `NO.${index + 1}`,

          exhaustGasTemp: getValue("Exhaust Gas Temperature"),

          avgDeviation: getValue("Average Temperature Deviation"),

          pistonCoolingOilTemp: getValue(
            "Piston Cooling Oil Outlet Temperature"
          ),

          jacketCoolingWaterTemp: getValue(
            "Jacket Cooling Water Outlet Temperature"
          ),
        };
      });

      setCylinders(formatted);
    } catch (error) {
      console.error("Error fetching cylinder telemetry:", error);
    } finally {
      setLoading(false);
    }
  };

  const columnStyle = {
    gridTemplateColumns: `140px repeat(${cylinders.length || 6}, 1fr)`,
  };

  return (
    <div className="em-cyl-section em-glass">
      {/* ======================================================
          TITLE
      ====================================================== */}

      <div className="em-exh-title">
        ME CYLINDER TELEMETRY
      </div>

      {/* ======================================================
          TABLE
      ====================================================== */}

      <div className="em-cyl-block">
        <div className="em-cyl-grid" style={columnStyle}>
          {/* HEADER ROW */}

          <div className="em-cyl-row-label"></div>

          {cylinders.map((c, i) => (
            <div key={i} className="em-exh-head">
              {c.no}
            </div>
          ))}

          {/* ======================================================
              Exhaust Gas Temperature
          ====================================================== */}

          <div className="em-cyl-row-label">
            Exh. Gas Temp
          </div>

          {loading ? (
            <div className="em-exh-val">Loading...</div>
          ) : (
            cylinders.map((c, i) => (
              <div key={i} className="em-exh-val">
                {Number(c.exhaustGasTemp).toFixed(1)} °C
              </div>
            ))
          )}

          {/* ======================================================
              Average Temperature Deviation
          ====================================================== */}

          <div className="em-cyl-row-label">
            Avg Deviation
          </div>

          {loading ? (
            <div className="em-exh-val">Loading...</div>
          ) : (
            cylinders.map((c, i) => (
              <div
                key={i}
                className="em-exh-val em-exh-dev"
                style={{
                  color: devColor(c.avgDeviation),
                }}
              >
                {fmtDev(c.avgDeviation)} °C
              </div>
            ))
          )}

          {/* ======================================================
              Piston Cooling Oil Outlet Temperature
          ====================================================== */}

          <div className="em-cyl-row-label">
            Piston Oil Temp
          </div>

          {loading ? (
            <div className="em-exh-val">Loading...</div>
          ) : (
            cylinders.map((c, i) => (
              <div key={i} className="em-exh-val">
                {Number(c.pistonCoolingOilTemp).toFixed(1)} °C
              </div>
            ))
          )}

          {/* ======================================================
              Jacket Cooling Water Outlet Temperature
          ====================================================== */}

          <div className="em-cyl-row-label">
            Jacket Water Temp
          </div>

          {loading ? (
            <div className="em-exh-val">Loading...</div>
          ) : (
            cylinders.map((c, i) => (
              <div key={i} className="em-exh-val">
                {Number(c.jacketCoolingWaterTemp).toFixed(1)} °C
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CylinderSection;